<template>
  <iModal
    :visible="addToNetworkModalOpen"
    title="Add To Network"
    :max-width="600"
    @close="closeModal"
  >
    <template #body>
      <iColumn gap="large">
        <iAutoComplete
          v-model="selectedNetworkId"
          :items="ownedNetworks"
          placeholder="Search for a network"
          item-label-key="name"
          item-value-key="network_id"
          width="fill"
          show-initial-results-on-click
          @item-selected="handleNetworkSelected"
        />
        <iColumn gap="extraSmall">
          <iHeading
            v-if="selectedNetworks.length > 0"
            variant="standard"
            font-size="small"
          >
            Selected networks:
          </iHeading>
          <iColumn v-if="selectedNetworks.length > 0" gap="extraSmall">
            <iRow
              v-for="network in selectedNetworks"
              :key="network.network_id"
              vertical-align="middle"
              gap="standard"
            >
              <iText>{{ network.name }}</iText>
              <iIcon
                icon="close"
                style="cursor: pointer"
                @click="removeNetwork(network)"
              />
            </iRow>
          </iColumn>
        </iColumn>
        <iText v-if="error" variant="error">
          {{ error }}
        </iText>
      </iColumn>
    </template>
    <template #footer>
      <iRow align="right" gap="standard">
        <iColumn width="hug">
          <iButton variant="secondary" @click="closeModal">
            Cancel
          </iButton>
        </iColumn>
        <iColumn width="hug">
          <iButton
            variant="primary"
            loading-spinner-position="inside"
            :is-loading="isLoadingAddPublicationToNetwork"
            @click="submit"
          >
            Add
          </iButton>
        </iColumn>
      </iRow>
    </template>
  </iModal>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useNetworkStore } from "@/stores/network-store";

export default {
  name: "AddToNetworkModal",
  data() {
    return {
      selectedNetworkId: null,
      selectedNetworks: [],
    };
  },
  computed: {
    ...mapState(useNetworkStore, [
      "addToNetworkModalOpen",
      "ownedNetworks",
      "isLoadingAddPublicationToNetwork",
      "error",
      "selectedPublicationId",
    ]),
  },
  methods: {
    ...mapActions(useNetworkStore, [
      "closeAddToNetworkModal",
      "addPublicationToNetworks",
    ]),
    handleNetworkSelected(network) {
      if (!network) {
        return;
      }
      const exists = this.selectedNetworks.some(
        network => network.network_id === network.network_id,
      );
      if (!exists) {
        this.selectedNetworks.push(network);
      }
      this.selectedNetworkId = null;
    },
    removeNetwork() {
      this.selectedNetworks = this.selectedNetworks.filter(
        network => network.network_id !== network.network_id,
      );
    },
    closeModal() {
      this.closeAddToNetworkModal();
      this.selectedNetworks = [];
      this.selectedNetworkId = null;
    },
    submit() {
      if (this.selectedNetworks.length === 0) {
        return;
      }
      const ids = this.selectedNetworks.map(n => n.network_id);
      this.addPublicationToNetworks(ids, this.selectedPublicationId, this.closeModal);
    },
  },
};
</script>

<style scoped>
</style>
